import React from "react";
import "../../styles/request_dashboard.scss";


interface RequestHeaderProps {
    data: {
        requestId?: string;
        requestDescription?: string;
        status?: string;
    };
    showStatus?: boolean;
}

const RequestHeader: React.FC<RequestHeaderProps> = ({ data, showStatus = false }) => {
    return (
        <div className="rh-container">
            <div className="rh-header-row" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span className="rh-label">
                    Request ID : {data?.requestId || "-"}
                </span>
                {showStatus && data?.status && (
                    <span
                        style={{
                            color: data.status.toUpperCase() === "CANCELLED" ? "#b91c1c" : "#757575",
                            fontSize: 12,
                            fontWeight: 600,
                        }}
                    >
                        Status: {data.status}
                    </span>
                )}
            </div>
            <p className="rh-description">
                {data?.requestDescription}
            </p>
        </div>
    );
};

export default RequestHeader;